// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Sd from "../tft-static/Sd.bs.js";
import * as Data9 from "./Data9.bs.js";
import * as Fnv1a from "../bindings/Fnv1a.bs.js";
import * as Data10 from "./Data10.bs.js";
import * as Data11 from "./Data11.bs.js";
import * as Data12 from "./Data12.bs.js";
import * as Data13 from "./Data13.bs.js";
import * as Data14 from "./Data14.bs.js";
import * as Data15 from "./Data15.bs.js";
import * as Data16 from "./Data16.bs.js";
import * as Data17 from "./Data17.bs.js";
import * as Data18 from "./Data18.bs.js";
import * as Data36 from "./Data36.bs.js";
import * as Data46 from "./Data46.bs.js";
import * as Data56 from "./Data56.bs.js";
import * as Data76 from "./Data76.bs.js";
import * as Data95 from "./Data95.bs.js";
import * as Global from "../Global.bs.js";
import * as Js_exn from "rescript/lib/es6/js_exn.js";
import * as Data101 from "./Data101.bs.js";
import * as Data151 from "./Data151.bs.js";
import * as Js_dict from "rescript/lib/es6/js_dict.js";
import * as Belt_Array from "rescript/lib/es6/belt_Array.js";
import * as Belt_Option from "rescript/lib/es6/belt_Option.js";
import * as Caml_option from "rescript/lib/es6/caml_option.js";
import * as DataBindJs from "./Data.bind.js";

function encodeItemId(prim) {
  return DataBindJs.encodeItemId(prim);
}

function encodeAugmentId(prim) {
  return DataBindJs.encodeAugmentId(prim);
}

function fixId(unitId) {
  return Sd.delowerId(unitId);
}

function units(set) {
  if (set >= 111) {
    if (set >= 141) {
      if (set === 170) {
        return Data17.units;
      }
      if (set >= 161) {
        if (set === 180) {
          return Data18.units;
        }
        
      } else if (set >= 150) {
        switch (set) {
          case 150 :
              return Data15.units;
          case 151 :
              return Data151.units;
          case 152 :
          case 153 :
          case 154 :
          case 155 :
          case 156 :
          case 157 :
          case 158 :
          case 159 :
              break;
          case 160 :
              return Data16.units;
          
        }
      }
      
    } else {
      if (set === 120) {
        return Data12.units;
      }
      if (set === 130) {
        return Data13.units;
      }
      if (set >= 140) {
        return Data14.units;
      }
      
    }
  } else if (set >= 47) {
    if (set === 56) {
      return Data56.units;
    }
    if (set === 76) {
      return Data76.units;
    }
    if (set >= 90) {
      switch (set) {
        case 90 :
            return Data9.units;
        case 95 :
            return Data95.units;
        case 100 :
            return Data10.units;
        case 101 :
            return Data101.units;
        case 91 :
        case 92 :
        case 93 :
        case 94 :
        case 96 :
        case 97 :
        case 98 :
        case 99 :
        case 102 :
        case 103 :
        case 104 :
        case 105 :
        case 106 :
        case 107 :
        case 108 :
        case 109 :
            break;
        case 110 :
            return Data11.units;
        
      }
    }
    
  } else {
    if (set === 10) {
      return Data10.units;
    }
    if (set === 36) {
      return Data36.units;
    }
    if (set >= 46) {
      return Data46.units;
    }
    
  }
  return Js_exn.raiseError("Invalid set " + String(set));
}

function traits(set) {
  if (set >= 111) {
    if (set >= 141) {
      if (set === 170) {
        return Data17.traits;
      }
      if (set >= 161) {
        if (set === 180) {
          return Data18.traits;
        }
        
      } else if (set >= 150) {
        switch (set) {
          case 150 :
              return Data15.traits;
          case 151 :
              return Data151.traits;
          case 152 :
          case 153 :
          case 154 :
          case 155 :
          case 156 :
          case 157 :
          case 158 :
          case 159 :
              break;
          case 160 :
              return Data16.traits;
          
        }
      }
      
    } else {
      if (set === 120) {
        return Data12.traits;
      }
      if (set === 130) {
        return Data13.traits;
      }
      if (set >= 140) {
        return Data14.traits;
      }
      
    }
  } else if (set >= 47) {
    if (set === 56) {
      return Data56.traits;
    }
    if (set === 76) {
      return Data76.traits;
    }
    if (set >= 90) {
      switch (set) {
        case 90 :
            return Data9.traits;
        case 95 :
            return Data95.traits;
        case 100 :
            return Data10.traits;
        case 101 :
            return Data101.traits;
        case 91 :
        case 92 :
        case 93 :
        case 94 :
        case 96 :
        case 97 :
        case 98 :
        case 99 :
        case 102 :
        case 103 :
        case 104 :
        case 105 :
        case 106 :
        case 107 :
        case 108 :
        case 109 :
            break;
        case 110 :
            return Data11.traits;
        
      }
    }
    
  } else {
    if (set === 10) {
      return Data10.traits;
    }
    if (set === 36) {
      return Data36.traits;
    }
    if (set >= 46) {
      return Data46.traits;
    }
    
  }
  return Js_exn.raiseError("Invalid set " + String(set));
}

function itemId(rawId) {
  return rawId.replace(/TFT(.*?)_Item_(.+)/, "$1$2");
}

function itemInfo(id, set) {
  if (set >= 111) {
    if (set >= 141) {
      if (set === 170) {
        return Js_dict.get(Data17.items, id);
      }
      if (set >= 161) {
        if (set === 180) {
          return Js_dict.get(Data18.items, id);
        }
        
      } else if (set >= 150) {
        switch (set) {
          case 150 :
              return Js_dict.get(Data15.items, id);
          case 151 :
              return Js_dict.get(Data151.items, id);
          case 152 :
          case 153 :
          case 154 :
          case 155 :
          case 156 :
          case 157 :
          case 158 :
          case 159 :
              break;
          case 160 :
              return Js_dict.get(Data16.items, id);
          
        }
      }
      
    } else {
      if (set === 120) {
        return Js_dict.get(Data12.items, id);
      }
      if (set === 130) {
        return Js_dict.get(Data13.items, id);
      }
      if (set >= 140) {
        return Js_dict.get(Data14.items, id);
      }
      
    }
  } else if (set >= 47) {
    if (set === 56) {
      return Js_dict.get(Data56.items, id);
    }
    if (set === 76) {
      return Js_dict.get(Data76.items, id);
    }
    if (set >= 90) {
      switch (set) {
        case 90 :
            return Js_dict.get(Data9.items, id);
        case 95 :
            var id$1 = id === "SeraphsEmbrace" ? "BlueBuff" : id;
            return Js_dict.get(Data95.items, id$1);
        case 100 :
            return Js_dict.get(Data10.items, id);
        case 101 :
            return Js_dict.get(Data101.items, id);
        case 91 :
        case 92 :
        case 93 :
        case 94 :
        case 96 :
        case 97 :
        case 98 :
        case 99 :
        case 102 :
        case 103 :
        case 104 :
        case 105 :
        case 106 :
        case 107 :
        case 108 :
        case 109 :
            break;
        case 110 :
            return Js_dict.get(Data11.items, id);
        
      }
    }
    
  } else {
    if (set === 10) {
      return Js_dict.get(Data10.items, id);
    }
    if (set === 36) {
      return Js_dict.get(Data36.items, id);
    }
    if (set >= 46) {
      return Js_dict.get(Data46.items, id);
    }
    
  }
  return Js_exn.raiseError("Invalid set " + String(set));
}

function itemInfoExn(id, set) {
  return Belt_Option.getExn(itemInfo(id, set));
}

function isModItem(id, set) {
  var info = itemInfo(id, set);
  if (info !== undefined) {
    return Caml_option.valFromOption(info).tags.includes("Mod");
  } else {
    return false;
  }
}

function items(set) {
  if (set >= 111) {
    if (set >= 141) {
      if (set === 170) {
        return Data17.items;
      }
      if (set >= 161) {
        if (set === 180) {
          return Data18.items;
        }
        
      } else if (set >= 150) {
        switch (set) {
          case 150 :
              return Data15.items;
          case 151 :
              return Data151.items;
          case 152 :
          case 153 :
          case 154 :
          case 155 :
          case 156 :
          case 157 :
          case 158 :
          case 159 :
              break;
          case 160 :
              return Data16.items;
          
        }
      }
      
    } else {
      if (set === 120) {
        return Data12.items;
      }
      if (set === 130) {
        return Data13.items;
      }
      if (set >= 140) {
        return Data14.items;
      }
      
    }
  } else if (set >= 47) {
    if (set === 56) {
      return Data56.items;
    }
    if (set === 76) {
      return Data76.items;
    }
    if (set >= 90) {
      switch (set) {
        case 90 :
            return Data9.items;
        case 95 :
            return Data95.items;
        case 100 :
            return Data10.items;
        case 101 :
            return Data101.items;
        case 91 :
        case 92 :
        case 93 :
        case 94 :
        case 96 :
        case 97 :
        case 98 :
        case 99 :
        case 102 :
        case 103 :
        case 104 :
        case 105 :
        case 106 :
        case 107 :
        case 108 :
        case 109 :
            break;
        case 110 :
            return Data11.items;
        
      }
    }
    
  } else {
    if (set === 10) {
      return Data10.items;
    }
    if (set === 36) {
      return Data36.items;
    }
    if (set >= 46) {
      return Data46.items;
    }
    
  }
  return Js_exn.raiseError("Invalid set " + String(set));
}

function itemsArr(set) {
  if (set >= 111) {
    if (set >= 141) {
      if (set === 170) {
        return Data17.itemsArr();
      }
      if (set >= 161) {
        if (set === 180) {
          return Data18.itemsArr();
        }
        
      } else if (set >= 150) {
        switch (set) {
          case 150 :
              return Data15.itemsArr();
          case 151 :
              return Data151.itemsArr();
          case 152 :
          case 153 :
          case 154 :
          case 155 :
          case 156 :
          case 157 :
          case 158 :
          case 159 :
              break;
          case 160 :
              return Data16.itemsArr();
          
        }
      }
      
    } else {
      if (set === 120) {
        return Data12.itemsArr();
      }
      if (set === 130) {
        return Data13.itemsArr();
      }
      if (set >= 140) {
        return Data14.itemsArr();
      }
      
    }
  } else if (set >= 47) {
    if (set === 56) {
      return Data56.itemsArr();
    }
    if (set === 76) {
      return Data76.itemsArr();
    }
    if (set >= 90) {
      switch (set) {
        case 90 :
            return Data9.itemsArr();
        case 95 :
            return Data95.itemsArr();
        case 100 :
            return Data10.itemsArr();
        case 101 :
            return Data101.itemsArr();
        case 91 :
        case 92 :
        case 93 :
        case 94 :
        case 96 :
        case 97 :
        case 98 :
        case 99 :
        case 102 :
        case 103 :
        case 104 :
        case 105 :
        case 106 :
        case 107 :
        case 108 :
        case 109 :
            break;
        case 110 :
            return Data11.itemsArr();
        
      }
    }
    
  } else {
    if (set === 10) {
      return Data10.itemsArr();
    }
    if (set === 36) {
      return Data36.itemsArr();
    }
    if (set >= 46) {
      return Data46.itemsArr();
    }
    
  }
  return Js_exn.raiseError("Invalid set " + String(set));
}

function augments(set) {
  if (set >= 111) {
    if (set >= 141) {
      if (set === 170) {
        return Data17.augments;
      }
      if (set >= 161) {
        if (set === 180) {
          return Data18.augments;
        }
        
      } else if (set >= 150) {
        switch (set) {
          case 150 :
              return Data15.augments;
          case 151 :
              return Data151.augments;
          case 152 :
          case 153 :
          case 154 :
          case 155 :
          case 156 :
          case 157 :
          case 158 :
          case 159 :
              break;
          case 160 :
              return Data16.augments;
          
        }
      }
      
    } else {
      if (set === 120) {
        return Data12.augments;
      }
      if (set === 130) {
        return Data13.augments;
      }
      if (set >= 140) {
        return Data14.augments;
      }
      
    }
  } else if (set >= 47) {
    if (set === 56) {
      return Data56.augments;
    }
    if (set === 76) {
      return Data76.augments;
    }
    if (set >= 90) {
      switch (set) {
        case 90 :
            return Data9.augments;
        case 95 :
            return Data95.augments;
        case 100 :
            return Data10.augments;
        case 101 :
            return Data101.augments;
        case 91 :
        case 92 :
        case 93 :
        case 94 :
        case 96 :
        case 97 :
        case 98 :
        case 99 :
        case 102 :
        case 103 :
        case 104 :
        case 105 :
        case 106 :
        case 107 :
        case 108 :
        case 109 :
            break;
        case 110 :
            return Data11.augments;
        
      }
    }
    
  } else {
    if (set === 10) {
      return Data10.augments;
    }
    if (set === 36) {
      return Data36.augments;
    }
    if (set >= 46) {
      return Data46.augments;
    }
    
  }
  return Js_exn.raiseError("Invalid set " + String(set));
}

function augmentId(rawId) {
  return rawId.replace(/TFT(.*?)_Augment_(.+)/, "$1$2");
}

function augmentInfo(id, set) {
  var id$1 = DataBindJs.encodeAugmentId(id);
  if (set >= 111) {
    if (set >= 141) {
      if (set === 170) {
        return Js_dict.get(Data17.augments, DataBindJs.encodeAugmentId(id$1));
      }
      if (set >= 161) {
        if (set === 180) {
          return Js_dict.get(Data18.augments, DataBindJs.encodeAugmentId(id$1));
        }
        
      } else if (set >= 150) {
        switch (set) {
          case 150 :
              return Js_dict.get(Data15.augments, DataBindJs.encodeAugmentId(id$1));
          case 151 :
              return Js_dict.get(Data151.augments, DataBindJs.encodeAugmentId(id$1));
          case 152 :
          case 153 :
          case 154 :
          case 155 :
          case 156 :
          case 157 :
          case 158 :
          case 159 :
              break;
          case 160 :
              return Js_dict.get(Data16.augments, DataBindJs.encodeAugmentId(id$1));
          
        }
      }
      
    } else {
      if (set === 120) {
        return Js_dict.get(Data12.augments, DataBindJs.encodeAugmentId(id$1));
      }
      if (set === 130) {
        return Js_dict.get(Data13.augments, DataBindJs.encodeAugmentId(id$1));
      }
      if (set >= 140) {
        return Js_dict.get(Data14.augments, DataBindJs.encodeAugmentId(id$1));
      }
      
    }
  } else if (set >= 47) {
    if (set === 56) {
      return Js_dict.get(Data56.augments, DataBindJs.encodeAugmentId(id$1));
    }
    if (set === 76) {
      return Js_dict.get(Data76.augments, DataBindJs.encodeAugmentId(id$1));
    }
    if (set >= 90) {
      switch (set) {
        case 90 :
            var v = Js_dict.get(Data9.augments, DataBindJs.encodeAugmentId(id$1));
            if (v !== undefined) {
              return v;
            } else {
              return Js_dict.get(Data9.legendAugments, DataBindJs.encodeAugmentId(id$1));
            }
        case 95 :
            return Js_dict.get(Data95.augments, DataBindJs.encodeAugmentId(id$1));
        case 100 :
            return Js_dict.get(Data10.augments, DataBindJs.encodeAugmentId(id$1));
        case 101 :
            return Js_dict.get(Data101.augments, DataBindJs.encodeAugmentId(id$1));
        case 91 :
        case 92 :
        case 93 :
        case 94 :
        case 96 :
        case 97 :
        case 98 :
        case 99 :
        case 102 :
        case 103 :
        case 104 :
        case 105 :
        case 106 :
        case 107 :
        case 108 :
        case 109 :
            break;
        case 110 :
            return Js_dict.get(Data11.augments, DataBindJs.encodeAugmentId(id$1));
        
      }
    }
    
  } else {
    if (set === 10) {
      return Js_dict.get(Data10.augments, DataBindJs.encodeAugmentId(id$1));
    }
    if (set === 36) {
      return Js_dict.get(Data36.augments, DataBindJs.encodeAugmentId(id$1));
    }
    if (set >= 46) {
      return Js_dict.get(Data46.augments, DataBindJs.encodeAugmentId(id$1));
    }
    
  }
  return Js_exn.raiseError("Invalid set " + String(set));
}

function augmentInfoExn(id, set) {
  return Belt_Option.getExn(augmentInfo(id, set));
}

function fixVarName(varName) {
  if (varName === "Exp") {
    return "EXP";
  } else {
    return varName;
  }
}

function replaceAugmentVariables(effects, desc, id, set) {
  var effects$1 = effects !== undefined ? Caml_option.valFromOption(effects) : augmentInfoExn(id, set).effects;
  var parts = Belt_Array.map(desc.split(new RegExp("(@.+?@)", "gm")), Belt_Option.getExn);
  return Belt_Array.map(parts, (function (part) {
                      if (part.charAt(0) !== "@") {
                        return part;
                      }
                      var p = part.slice(1, part.length - 1 | 0);
                      var adjP = Belt_Array.getExn(p.split("*"), 0);
                      var f = Js_dict.get(effects$1, fixVarName(adjP));
                      var v = f !== undefined ? f : Js_dict.get(effects$1, "{" + Fnv1a.ritoHash(fixVarName(adjP)) + "}");
                      if (v == null) {
                        return "0";
                      } else if (part.includes("*100")) {
                        return Global.formatPctSmart(v);
                      } else {
                        return Global.toFixedSmart(v);
                      }
                    })).join("").replace("%%", "%").replace("%%", "%");
}

var ornnItems = [
  "4OrnnAnimaVisage",
  "4OrnnDeathsDefiance",
  "4OrnnEternalWinter",
  "4OrnnInfinityForce",
  "4OrnnMuramana",
  "4OrnnObsidianCleaver",
  "4OrnnRanduinsSanctum",
  "4OrnnRocketPropelledFist",
  "4OrnnTheCollector",
  "4OrnnZhonyasParadox"
];

export {
  encodeItemId ,
  encodeAugmentId ,
  fixId ,
  units ,
  traits ,
  itemId ,
  itemInfo ,
  itemInfoExn ,
  isModItem ,
  items ,
  itemsArr ,
  augments ,
  augmentId ,
  augmentInfo ,
  augmentInfoExn ,
  fixVarName ,
  replaceAugmentVariables ,
  ornnItems ,
  
}
/* Sd Not a pure module */
